import React, {Suspense} from 'react';
import ReactDOM from 'react-dom/client';
import {BrowserRouter} from 'react-router-dom';
import App from './App';
import reportWebVitals from './reportWebVitals';
import './index.css';
import './i18n';

const loadingMarkup = (
    <div className="flex justify-center items-center h-[100vh]">
        <img className={"m-auto"} src={"/images/mbloader.gif"} alt={"BOM loader"}/>
    </div>
)

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <Suspense fallback={loadingMarkup}>
        <React.StrictMode>
            <BrowserRouter>
                <App/>
            </BrowserRouter>
        </React.StrictMode>
    </Suspense>
);

reportWebVitals();
